import React from 'react';
import PropTypes from 'prop-types';

import GamingStepper from './GamingStepper';
import CreateStudyContainer from '../CreateStudyContainer';

const GamingContainer = ({history}) => {
  return (
    <CreateStudyContainer>
      <GamingStepper {...{history}} />
    </CreateStudyContainer>
  );
};

GamingContainer.propTypes = {
  history: PropTypes.object,
};

export default GamingContainer;
